module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-color"
  }, [_c('div', {
    staticClass: "container blog-display"
  }, [_c('div', {
    staticClass: "inner-blog"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "blog-list news_block"
  }, [_c('ul', _vm._l((_vm.fetchedData), function(data) {
    return _c('li', [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "blog-image"
    }, [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.attributes.medium_image,
        "alt": "earth"
      }
    })])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('div', {
      staticClass: "news_in blog-detail"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_vm._v(_vm._s(data.attributes.title))])], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("convertDate")(data.attributes.event_date)))]), _vm._v(" "), _c('h6', {
      staticClass: "para"
    }, [_vm._v(_vm._s(_vm._f("escape")(_vm._f("truncate")(data.attributes.description))))])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('popular')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc9f09a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources.vue
// module id = 303
// module chunks = 1